import { HttpClient } from '@angular/common/http';
import { ThrowStmt } from '@angular/compiler';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CardManagementService {

  cards: Card[] = [
    { front: 'kot', back: 'cat' },
    { front: 'pies', back: 'dog' }];

  constructor(private http: HttpClient) {
    const db = JSON.parse(
      localStorage.getItem('fiszki-db')
    )
    if (db) {
      this.cards = db;
    }
  }

  get() {
    return this.cards;
  }

  post(card) {
    this.cards.push(card);
    this.saveDb();
  }

  delete(card) {
    const index = this.cards.findIndex(c => c.front === card.front && c.back === card.back);
    if (index > -1) {
      this.cards.splice(index, 1);
      this.saveDb();
    }
  }

  saveDb() {
    localStorage.setItem('fiszki-db', JSON.stringify(this.cards));
  }
}

export interface Card {
  front?: string;
  back?: string;
}
